(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["Websandbox"] = factory();
	else
		root["Websandbox"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 3);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TYPE_MESSAGE = exports.TYPE_MESSAGE = 'message';
var TYPE_RESPONSE = exports.TYPE_RESPONSE = 'response';
var TYPE_SET_INTERFACE = exports.TYPE_SET_INTERFACE = 'set-interface';
var TYPE_SERVICE_MESSAGE = exports.TYPE_SERVICE_MESSAGE = 'service-message';

var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;

var defaultOptions = {
  //Will not affect IE11 because there sandboxed iframe has not 'null' origin
  //but base URL of iframe's src
  allowedSenderOrigin: undefined
};

var Connection = function () {
  function Connection(postMessage, registerOnMessageListener, options) {
    var _this = this;

    _classCallCheck(this, Connection);

    this.options = _extends({}, defaultOptions, options);
    //Random number between 0 and 100000
    this.incrementalID = Math.floor(Math.random() * 100000);

    this.postMessage = postMessage;
    this.remote = {};
    this.callbacks = {};

    this.remoteMethodsWaitPromise = new Promise(function (resolve) {
      _this._resolveRemoteMethodsPromise = resolve;
    });

    registerOnMessageListener(function () {
      return _this.onMessageListener.apply(_this, arguments);
    });
  }

  /**
     * Listens to remote messages. Calls local method if it is called outside or call stored callback if it is response.
     * @param e - onMessage event
     */


  _createClass(Connection, [{
    key: 'onMessageListener',
    value: function onMessageListener(e) {
      var _this2 = this;

      var data = e.data;

      var allowedSenderOrigin = this.options.allowedSenderOrigin;

      if (allowedSenderOrigin && e.origin !== allowedSenderOrigin && !isIE11) {
        return;
      }

      if (data.type === TYPE_RESPONSE) {
        this.popCallback(data.callId, data.success, data.result);
      } else if (data.type === TYPE_MESSAGE) {
        this.callLocalApi(data.methodName, data.arguments).then(function (res) {
          return _this2.responseOtherSide(data.callId, res);
        }).catch(function (err) {
          return _this2.responseOtherSide(data.callId, err, false);
        });
      } else if (data.type === TYPE_SET_INTERFACE) {
        this.setInterface(data.apiMethods);
        this.responseOtherSide(data.callId);
      } else if (data.type === TYPE_SERVICE_MESSAGE) {
        this.callLocalServiceMethod(data.methodName, data.arguments).then(function (res) {
          return _this2.responseOtherSide(data.callId, res);
        }).catch(function (err) {
          return _this2.responseOtherSide(data.callId, err, false);
        });
      }
    }
  }, {
    key: 'postMessageToOtherSide',
    value: function postMessageToOtherSide(dataToPost) {
      this.postMessage(dataToPost, '*');
    }

    /**
       * Sets remote interface methods
       * @param remote - hash with keys of remote API methods. Values is ignored
       */

  }, {
    key: 'setInterface',
    value: function setInterface(remoteMethods) {
      var _this3 = this;

      this.remote = {};

      remoteMethods.forEach(function (key) {
        return _this3.remote[key] = _this3.createMethodWrapper(key);
      });

      this._resolveRemoteMethodsPromise();
    }
  }, {
    key: 'setLocalApi',
    value: function setLocalApi(api) {
      var _this4 = this;

      return new Promise(function (resolve, reject) {
        var id = _this4.registerCallback(resolve, reject);
        _this4.postMessageToOtherSide({
          callId: id,
          apiMethods: Object.keys(api),
          type: TYPE_SET_INTERFACE
        });
      }).then(function () {
        return _this4.localApi = api;
      });
    }
  }, {
    key: 'setServiceMethods',
    value: function setServiceMethods(api) {
      this.serviceMethods = api;
    }

    /**
       * Calls local method
       * @param methodName
       * @param args
       * @returns {Promise.<*>|string}
       */

  }, {
    key: 'callLocalApi',
    value: function callLocalApi(methodName, args) {
      var _localApi;

      return Promise.resolve((_localApi = this.localApi)[methodName].apply(_localApi, _toConsumableArray(args)));
    }

    /**
       * Calls local method registered as "service method"
       * @param methodName
       * @param args
       * @returns {Promise.<*>}
       */

  }, {
    key: 'callLocalServiceMethod',
    value: function callLocalServiceMethod(methodName, args) {
      var _serviceMethods;

      if (!this.serviceMethods[methodName]) {
        throw new Error('Serivce method ' + methodName + ' is not registered');
      }
      return Promise.resolve((_serviceMethods = this.serviceMethods)[methodName].apply(_serviceMethods, _toConsumableArray(args)));
    }

    /**
       * Wraps remote method with callback storing code
       * @param methodName - method to wrap
       * @returns {Function} - function to call as remote API interface
       */

  }, {
    key: 'createMethodWrapper',
    value: function createMethodWrapper(methodName) {
      var _this5 = this;

      return function () {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _this5.callRemoteMethod.apply(_this5, [methodName].concat(args));
      };
    }

    /**
       * Calls other side with arguments provided
       * @param id
       * @param methodName
       * @param args
       */

  }, {
    key: 'callRemoteMethod',
    value: function callRemoteMethod(methodName) {
      var _this6 = this;

      for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      return new Promise(function (resolve, reject) {
        var id = _this6.registerCallback(resolve, reject);
        _this6.postMessageToOtherSide({
          callId: id,
          methodName: methodName,
          type: TYPE_MESSAGE,
          arguments: args
        });
      });
    }

    /**
       * Calls remote service method
       * @param methodName
       * @param args
       * @returns {*}
       */

  }, {
    key: 'callRemoteServiceMethod',
    value: function callRemoteServiceMethod(methodName) {
      var _this7 = this;

      for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
        args[_key3 - 1] = arguments[_key3];
      }

      return new Promise(function (resolve, reject) {
        var id = _this7.registerCallback(resolve, reject);
        _this7.postMessageToOtherSide({
          callId: id,
          methodName: methodName,
          type: TYPE_SERVICE_MESSAGE,
          arguments: args
        });
      });
    }

    /**
       * Respond to remote call
       * @param id - remote call ID
       * @param result - result to pass to calling function
       */

  }, {
    key: 'responseOtherSide',
    value: function responseOtherSide(id, result) {
      var _this8 = this;

      var success = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      if (result instanceof Error) {
        // Error could be non-serializable, so we copy properties manually
        result = [].concat(_toConsumableArray(Object.keys(result)), ['message']).reduce(function (acc, it) {
          acc[it] = result[it];
          return acc;
        }, {});
      }

      var doPost = function doPost() {
        return _this8.postMessage({
          callId: id,
          type: TYPE_RESPONSE,
          success: success,
          result: result
        }, '*');
      };

      try {
        doPost();
      } catch (err) {
        console.error('Failed to post response, recovering...', err); // eslint-disable-line no-console
        if (err instanceof DOMException) {
          result = JSON.parse(JSON.stringify(result));
          doPost();
        }
      }
    }

    /**
       * Stores callbacks to call later when remote call will be answered
       * @param successCallback
       * @param failureCallback
       */

  }, {
    key: 'registerCallback',
    value: function registerCallback(successCallback, failureCallback) {
      var id = (++this.incrementalID).toString();
      this.callbacks[id] = { successCallback: successCallback, failureCallback: failureCallback };
      return id;
    }

    /**
       * Calls and delete stored callback
       * @param id - call id
       * @param success - was call successful
       * @param result - result of remote call
       */

  }, {
    key: 'popCallback',
    value: function popCallback(id, success, result) {
      if (success) {
        this.callbacks[id].successCallback(result);
      } else {
        this.callbacks[id].failureCallback(result);
      }
      delete this.callbacks[id];
    }
  }]);

  return Connection;
}();

exports.default = Connection;

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = "/******/ (function(modules) { // webpackBootstrap\n/******/ \t// The module cache\n/******/ \tvar installedModules = {};\n/******/\n/******/ \t// The require function\n/******/ \tfunction __webpack_require__(moduleId) {\n/******/\n/******/ \t\t// Check if module is in cache\n/******/ \t\tif(installedModules[moduleId]) {\n/******/ \t\t\treturn installedModules[moduleId].exports;\n/******/ \t\t}\n/******/ \t\t// Create a new module (and put it into the cache)\n/******/ \t\tvar module = installedModules[moduleId] = {\n/******/ \t\t\ti: moduleId,\n/******/ \t\t\tl: false,\n/******/ \t\t\texports: {}\n/******/ \t\t};\n/******/\n/******/ \t\t// Execute the module function\n/******/ \t\tmodules[moduleId].call(module.exports, module, module.exports, __webpack_require__);\n/******/\n/******/ \t\t// Flag the module as loaded\n/******/ \t\tmodule.l = true;\n/******/\n/******/ \t\t// Return the exports of the module\n/******/ \t\treturn module.exports;\n/******/ \t}\n/******/\n/******/\n/******/ \t// expose the modules object (__webpack_modules__)\n/******/ \t__webpack_require__.m = modules;\n/******/\n/******/ \t// expose the module cache\n/******/ \t__webpack_require__.c = installedModules;\n/******/\n/******/ \t// identity function for calling harmony imports with the correct context\n/******/ \t__webpack_require__.i = function(value) { return value; };\n/******/\n/******/ \t// define getter function for harmony exports\n/******/ \t__webpack_require__.d = function(exports, name, getter) {\n/******/ \t\tif(!__webpack_require__.o(exports, name)) {\n/******/ \t\t\tObject.defineProperty(exports, name, {\n/******/ \t\t\t\tconfigurable: false,\n/******/ \t\t\t\tenumerable: true,\n/******/ \t\t\t\tget: getter\n/******/ \t\t\t});\n/******/ \t\t}\n/******/ \t};\n/******/\n/******/ \t// getDefaultExport function for compatibility with non-harmony modules\n/******/ \t__webpack_require__.n = function(module) {\n/******/ \t\tvar getter = module && module.__esModule ?\n/******/ \t\t\tfunction getDefault() { return module['default']; } :\n/******/ \t\t\tfunction getModuleExports() { return module; };\n/******/ \t\t__webpack_require__.d(getter, 'a', getter);\n/******/ \t\treturn getter;\n/******/ \t};\n/******/\n/******/ \t// Object.prototype.hasOwnProperty.call\n/******/ \t__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };\n/******/\n/******/ \t// __webpack_public_path__\n/******/ \t__webpack_require__.p = \"\";\n/******/\n/******/ \t// Load entry module and return exports\n/******/ \treturn __webpack_require__(__webpack_require__.s = 1);\n/******/ })\n/************************************************************************/\n/******/ ([\n/* 0 */\n/***/ (function(module, exports, __webpack_require__) {\n\n\"use strict\";\n\n\nObject.defineProperty(exports, \"__esModule\", {\n  value: true\n});\n\nvar _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };\n\nvar _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if (\"value\" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();\n\nfunction _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }\n\nfunction _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError(\"Cannot call a class as a function\"); } }\n\nvar TYPE_MESSAGE = exports.TYPE_MESSAGE = 'message';\nvar TYPE_RESPONSE = exports.TYPE_RESPONSE = 'response';\nvar TYPE_SET_INTERFACE = exports.TYPE_SET_INTERFACE = 'set-interface';\nvar TYPE_SERVICE_MESSAGE = exports.TYPE_SERVICE_MESSAGE = 'service-message';\n\nvar isIE11 = !!window.MSInputMethodContext && !!document.documentMode;\n\nvar defaultOptions = {\n  //Will not affect IE11 because there sandboxed iframe has not 'null' origin\n  //but base URL of iframe's src\n  allowedSenderOrigin: undefined\n};\n\nvar Connection = function () {\n  function Connection(postMessage, registerOnMessageListener, options) {\n    var _this = this;\n\n    _classCallCheck(this, Connection);\n\n    this.options = _extends({}, defaultOptions, options);\n    //Random number between 0 and 100000\n    this.incrementalID = Math.floor(Math.random() * 100000);\n\n    this.postMessage = postMessage;\n    this.remote = {};\n    this.callbacks = {};\n\n    this.remoteMethodsWaitPromise = new Promise(function (resolve) {\n      _this._resolveRemoteMethodsPromise = resolve;\n    });\n\n    registerOnMessageListener(function () {\n      return _this.onMessageListener.apply(_this, arguments);\n    });\n  }\n\n  /**\n     * Listens to remote messages. Calls local method if it is called outside or call stored callback if it is response.\n     * @param e - onMessage event\n     */\n\n\n  _createClass(Connection, [{\n    key: 'onMessageListener',\n    value: function onMessageListener(e) {\n      var _this2 = this;\n\n      var data = e.data;\n\n      var allowedSenderOrigin = this.options.allowedSenderOrigin;\n\n      if (allowedSenderOrigin && e.origin !== allowedSenderOrigin && !isIE11) {\n        return;\n      }\n\n      if (data.type === TYPE_RESPONSE) {\n        this.popCallback(data.callId, data.success, data.result);\n      } else if (data.type === TYPE_MESSAGE) {\n        this.callLocalApi(data.methodName, data.arguments).then(function (res) {\n          return _this2.responseOtherSide(data.callId, res);\n        }).catch(function (err) {\n          return _this2.responseOtherSide(data.callId, err, false);\n        });\n      } else if (data.type === TYPE_SET_INTERFACE) {\n        this.setInterface(data.apiMethods);\n        this.responseOtherSide(data.callId);\n      } else if (data.type === TYPE_SERVICE_MESSAGE) {\n        this.callLocalServiceMethod(data.methodName, data.arguments).then(function (res) {\n          return _this2.responseOtherSide(data.callId, res);\n        }).catch(function (err) {\n          return _this2.responseOtherSide(data.callId, err, false);\n        });\n      }\n    }\n  }, {\n    key: 'postMessageToOtherSide',\n    value: function postMessageToOtherSide(dataToPost) {\n      this.postMessage(dataToPost, '*');\n    }\n\n    /**\n       * Sets remote interface methods\n       * @param remote - hash with keys of remote API methods. Values is ignored\n       */\n\n  }, {\n    key: 'setInterface',\n    value: function setInterface(remoteMethods) {\n      var _this3 = this;\n\n      this.remote = {};\n\n      remoteMethods.forEach(function (key) {\n        return _this3.remote[key] = _this3.createMethodWrapper(key);\n      });\n\n      this._resolveRemoteMethodsPromise();\n    }\n  }, {\n    key: 'setLocalApi',\n    value: function setLocalApi(api) {\n      var _this4 = this;\n\n      return new Promise(function (resolve, reject) {\n        var id = _this4.registerCallback(resolve, reject);\n        _this4.postMessageToOtherSide({\n          callId: id,\n          apiMethods: Object.keys(api),\n          type: TYPE_SET_INTERFACE\n        });\n      }).then(function () {\n        return _this4.localApi = api;\n      });\n    }\n  }, {\n    key: 'setServiceMethods',\n    value: function setServiceMethods(api) {\n      this.serviceMethods = api;\n    }\n\n    /**\n       * Calls local method\n       * @param methodName\n       * @param args\n       * @returns {Promise.<*>|string}\n       */\n\n  }, {\n    key: 'callLocalApi',\n    value: function callLocalApi(methodName, args) {\n      var _localApi;\n\n      return Promise.resolve((_localApi = this.localApi)[methodName].apply(_localApi, _toConsumableArray(args)));\n    }\n\n    /**\n       * Calls local method registered as \"service method\"\n       * @param methodName\n       * @param args\n       * @returns {Promise.<*>}\n       */\n\n  }, {\n    key: 'callLocalServiceMethod',\n    value: function callLocalServiceMethod(methodName, args) {\n      var _serviceMethods;\n\n      if (!this.serviceMethods[methodName]) {\n        throw new Error('Serivce method ' + methodName + ' is not registered');\n      }\n      return Promise.resolve((_serviceMethods = this.serviceMethods)[methodName].apply(_serviceMethods, _toConsumableArray(args)));\n    }\n\n    /**\n       * Wraps remote method with callback storing code\n       * @param methodName - method to wrap\n       * @returns {Function} - function to call as remote API interface\n       */\n\n  }, {\n    key: 'createMethodWrapper',\n    value: function createMethodWrapper(methodName) {\n      var _this5 = this;\n\n      return function () {\n        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {\n          args[_key] = arguments[_key];\n        }\n\n        return _this5.callRemoteMethod.apply(_this5, [methodName].concat(args));\n      };\n    }\n\n    /**\n       * Calls other side with arguments provided\n       * @param id\n       * @param methodName\n       * @param args\n       */\n\n  }, {\n    key: 'callRemoteMethod',\n    value: function callRemoteMethod(methodName) {\n      var _this6 = this;\n\n      for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {\n        args[_key2 - 1] = arguments[_key2];\n      }\n\n      return new Promise(function (resolve, reject) {\n        var id = _this6.registerCallback(resolve, reject);\n        _this6.postMessageToOtherSide({\n          callId: id,\n          methodName: methodName,\n          type: TYPE_MESSAGE,\n          arguments: args\n        });\n      });\n    }\n\n    /**\n       * Calls remote service method\n       * @param methodName\n       * @param args\n       * @returns {*}\n       */\n\n  }, {\n    key: 'callRemoteServiceMethod',\n    value: function callRemoteServiceMethod(methodName) {\n      var _this7 = this;\n\n      for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {\n        args[_key3 - 1] = arguments[_key3];\n      }\n\n      return new Promise(function (resolve, reject) {\n        var id = _this7.registerCallback(resolve, reject);\n        _this7.postMessageToOtherSide({\n          callId: id,\n          methodName: methodName,\n          type: TYPE_SERVICE_MESSAGE,\n          arguments: args\n        });\n      });\n    }\n\n    /**\n       * Respond to remote call\n       * @param id - remote call ID\n       * @param result - result to pass to calling function\n       */\n\n  }, {\n    key: 'responseOtherSide',\n    value: function responseOtherSide(id, result) {\n      var _this8 = this;\n\n      var success = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;\n\n      if (result instanceof Error) {\n        // Error could be non-serializable, so we copy properties manually\n        result = [].concat(_toConsumableArray(Object.keys(result)), ['message']).reduce(function (acc, it) {\n          acc[it] = result[it];\n          return acc;\n        }, {});\n      }\n\n      var doPost = function doPost() {\n        return _this8.postMessage({\n          callId: id,\n          type: TYPE_RESPONSE,\n          success: success,\n          result: result\n        }, '*');\n      };\n\n      try {\n        doPost();\n      } catch (err) {\n        console.error('Failed to post response, recovering...', err); // eslint-disable-line no-console\n        if (err instanceof DOMException) {\n          result = JSON.parse(JSON.stringify(result));\n          doPost();\n        }\n      }\n    }\n\n    /**\n       * Stores callbacks to call later when remote call will be answered\n       * @param successCallback\n       * @param failureCallback\n       */\n\n  }, {\n    key: 'registerCallback',\n    value: function registerCallback(successCallback, failureCallback) {\n      var id = (++this.incrementalID).toString();\n      this.callbacks[id] = { successCallback: successCallback, failureCallback: failureCallback };\n      return id;\n    }\n\n    /**\n       * Calls and delete stored callback\n       * @param id - call id\n       * @param success - was call successful\n       * @param result - result of remote call\n       */\n\n  }, {\n    key: 'popCallback',\n    value: function popCallback(id, success, result) {\n      if (success) {\n        this.callbacks[id].successCallback(result);\n      } else {\n        this.callbacks[id].failureCallback(result);\n      }\n      delete this.callbacks[id];\n    }\n  }]);\n\n  return Connection;\n}();\n\nexports.default = Connection;\n\n/***/ }),\n/* 1 */\n/***/ (function(module, exports, __webpack_require__) {\n\n\"use strict\";\n\n\nvar _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if (\"value\" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();\n\nvar _connection = __webpack_require__(0);\n\nvar _connection2 = _interopRequireDefault(_connection);\n\nfunction _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }\n\nfunction _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError(\"Cannot call a class as a function\"); } }\n\nvar Frame = function () {\n  function Frame() {\n    var _this = this;\n\n    _classCallCheck(this, Frame);\n\n    this.connection = new _connection2.default(window.parent.postMessage.bind(window.parent), function (listener) {\n      window.addEventListener('message', listener);\n    });\n\n    this.connection.setServiceMethods({\n      runCode: function runCode(code) {\n        return _this.runCode(code);\n      },\n      importScript: function importScript(path) {\n        return _this.importScript(path);\n      },\n      injectStyle: function injectStyle(style) {\n        return _this.injectStyle(style);\n      },\n      importStyle: function importStyle(path) {\n        return _this.importStyle(path);\n      }\n    });\n\n    this.connection.callRemoteServiceMethod('iframeInitialized');\n  }\n\n  /**\n     * Creates script tag with passed code and attaches it. Runs synchronous\n     * @param code\n     */\n\n\n  _createClass(Frame, [{\n    key: 'runCode',\n    value: function runCode(code) {\n      var scriptTag = document.createElement('script');\n      scriptTag.innerHTML = code;\n      document.getElementsByTagName('head')[0].appendChild(scriptTag);\n    }\n  }, {\n    key: 'importScript',\n    value: function importScript(scriptUrl) {\n      var scriptTag = document.createElement('script');\n      scriptTag.src = scriptUrl;\n      document.getElementsByTagName('head')[0].appendChild(scriptTag);\n      return new Promise(function (resolve) {\n        return scriptTag.onload = function () {\n          return resolve();\n        };\n      });\n    }\n  }, {\n    key: 'injectStyle',\n    value: function injectStyle(style) {\n      var styleTag = document.createElement('style');\n      styleTag.innerHTML = style;\n      document.getElementsByTagName('head')[0].appendChild(styleTag);\n    }\n  }, {\n    key: 'importStyle',\n    value: function importStyle(styleUrl) {\n      var linkTag = document.createElement('link');\n      linkTag.rel = 'stylesheet';\n      linkTag.href = styleUrl;\n      document.getElementsByTagName('head')[0].appendChild(linkTag);\n    }\n  }]);\n\n  return Frame;\n}();\n\nvar Websandbox = new Frame();\nwindow.Websandbox = window.Websandbox || Websandbox;\nmodule.exports = Websandbox; // eslint-disable-line\n\n/***/ })\n/******/ ]);\n//# sourceMappingURL=compile-loader-file-name.js.map"

/***/ }),
/* 2 */,
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BaseOptions = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _connection = __webpack_require__(0);

var _connection2 = _interopRequireDefault(_connection);

var _frame = __webpack_require__(1);

var _frame2 = _interopRequireDefault(_frame);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @typedef {Object} SandboxOptions
 * @property {string|DOMNode} frameContainer A selector or DOM node where iframe will be appended
 * @property {string} frameClassName A class that <iframe/> element will has
 * @property {string} frameSrc A url of iframe content. 
 * If set, "frameContent", "codeToRunBeforeInit", "initialStyles", "baseUrl" won't take any effect.
 * In order to work properly, html file by frameSrc should have ./frame.js code bundled
 * @property {?string} frameContent A content of sandbox iFrame
 * @property {?string} codeToRunBeforeInit A js code to run before any other iFrame code (will be injected in <head/>)
 * @property {?string} initialStyles A CSS markup to inject into iFrame <head/>
 * @property {?string} baseUrl A URL that will be used as base url for all relative 
 * pathes in tags like <script/>, <link/>. See https://developer.mozilla.org/en-US/docs/Web/HTML/Element/base
 * @property {?boolean} allowPointerLock Is sandboxed iFrame allowed to capture pointer. See https://developer.mozilla.org/en-US/docs/Web/HTML/Element/iframe
 * @property {?boolean} allowFullScreen Is iFrame allowed to go fullscreen. See https://developer.mozilla.org/en-US/docs/Web/HTML/Element/iframe
 */
var BaseOptions = exports.BaseOptions = {
  frameContainer: 'body',
  frameClassName: 'websandbox__frame',
  frameSrc: null,
  frameContent: '\n<!DOCTYPE html>\n<html>\n<head><meta charset="UTF-8"></head>\n<body></body>\n</html>\n  ',
  codeToRunBeforeInit: null,
  initialStyles: null,
  baseUrl: null,
  allowPointerLock: false,
  allowFullScreen: false,
  sandboxAdditionalAttributes: ''
};

var Websandbox = function () {
  _createClass(Websandbox, null, [{
    key: 'create',

    /**
     * Creates sandbox instancea
     * @param {?Object} localApi Api of this side. Will be available for sandboxed code as remoteApi
     * @param {?SandboxOptions} options Options of created sandbox
     */
    value: function create(localApi) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return new Websandbox(localApi, _extends(BaseOptions, options));
    }

    /**
     * {Constructor}
     * @param {?Object} localApi
     * @param {?SandboxOptions} options
     */

  }]);

  function Websandbox(localApi, options) {
    var _this = this;

    _classCallCheck(this, Websandbox);

    this.options = options;
    this.iframe = this.createIframe();

    this.promise = new Promise(function (resolve) {
      _this.connection = new _connection2.default(_this.iframe.contentWindow.postMessage.bind(_this.iframe.contentWindow), function (listener) {
        var sourceCheckListener = function sourceCheckListener(event) {
          if (event.source !== _this.iframe.contentWindow) {
            return;
          }
          return listener(event);
        };
        window.addEventListener('message', sourceCheckListener);
        _this.removeMessageListener = function () {
          return window.removeEventListener('message', sourceCheckListener);
        };
      }, { allowedSenderOrigin: 'null' });

      _this.connection.setServiceMethods({
        iframeInitialized: function iframeInitialized() {
          return _this.connection.setLocalApi(localApi).then(function () {
            return resolve(_this);
          });
        }
      });
    });
  }

  _createClass(Websandbox, [{
    key: '_prepareFrameContent',
    value: function _prepareFrameContent(options) {
      var frameContent = options.frameContent.replace('</head>', '<script>' + _frame2.default + '</script>\n</head>');

      if (options.initialStyles) {
        frameContent = frameContent.replace('</head>', '<style>' + options.initialStyles + '</style>\n</head>');
      }

      if (options.baseUrl) {
        frameContent = frameContent.replace('<head>', '<head>\n<base href="' + options.baseUrl + '"/>');
      }

      if (options.codeToRunBeforeInit) {
        frameContent = frameContent.replace('<head>', '<head>\n<script>' + options.codeToRunBeforeInit + '</script>');
      }
      return frameContent;
    }
  }, {
    key: 'createIframe',
    value: function createIframe() {
      var containerSelector = this.options.frameContainer;
      var container = typeof containerSelector === 'string' ? document.querySelector(containerSelector) : containerSelector;

      if (!container) {
        throw new Error('Websandbox: Cannot find container for sandbox ' + container);
      }

      var frame = document.createElement('iframe');
      frame.sandbox = 'allow-scripts ' + this.options.sandboxAdditionalAttributes;
      frame.className = this.options.frameClassName;
      if (this.options.allowFullScreen) {
        frame.allowfullscreen = "true";
      }

      if (this.options.frameSrc) {
        frame.src = this.options.frameSrc;
        container.appendChild(frame);
        return frame;
      }

      if (this.options.frameContent.indexOf('<head>') < 0) {
        throw new Error('Websandbox: iFrame content must have "<head>" tag.');
      }

      frame.setAttribute('srcdoc', this._prepareFrameContent(this.options));
      container.appendChild(frame);
      return frame;
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      this.iframe.remove();
      this.removeMessageListener();
    }
  }, {
    key: '_runCode',
    value: function _runCode(code) {
      return this.connection.callRemoteServiceMethod('runCode', code);
    }
  }, {
    key: '_runFunction',
    value: function _runFunction(fn) {
      return this._runCode('(' + fn.toString() + ')()');
    }
  }, {
    key: 'run',
    value: function run(codeOrFunction) {
      if (codeOrFunction.name) {
        return this._runFunction(codeOrFunction);
      }
      return this._runCode(codeOrFunction);
    }
  }, {
    key: 'importScript',
    value: function importScript(path) {
      return this.connection.callRemoteServiceMethod('importScript', path);
    }
  }, {
    key: 'injectStyle',
    value: function injectStyle(style) {
      return this.connection.callRemoteServiceMethod('injectStyle', style);
    }
  }]);

  return Websandbox;
}();

exports.default = Websandbox;

/***/ })
/******/ ]);
});
//# sourceMappingURL=websandbox.js.map